import buildUrl from 'build-url'
import BaseAPIService from '@/services/baseAPIService'

export default class AnalyticsAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Contacts
  getContactSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/contacts/summary${queryString}`, { reportingAPI: true })
  }
  getContactMinSpendList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/contacts/credit/minspendlist${queryString}`, { reportingAPI: true })
  }
  getContactOrderVariationSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/contacts/orders/variationsummary${queryString}`, { reportingAPI: true })
  }
  
  // Inventory
  getStockValueOnHandSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/inventory/stockvalueonhand/summary${queryString}`, { reportingAPI: true })
  }
  getStockOnHandSummary()         { return this.cachedGet(`/intelligence/inventory/stockonhand/summary`, { reportingAPI: true }) }
  getStockOnHandGlassChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/inventory/stockonhand/glass/chartdata${queryString}`, { reportingAPI: true })
  }
  getStockOnHandTreeMap(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/inventory/stockonhand/glass/treemapdata${queryString}`, { reportingAPI: true })
  }

  getInventoryValueChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/inventory/stockvalueonhand/chartdata${queryString}`, { reportingAPI: true })
  }
  getInventoryUsageChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/inventory/usage/chartdata${queryString}`, { reportingAPI: true })
  }
  getInventoryTransactionChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/inventory/transactions/chartdata${queryString}`, { reportingAPI: true })
  }

  getGlassSizeSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/inventory/glasssizes/summary${queryString}`, { reportingAPI: true })
  }
  getGlassSizeMovingAverageChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/inventory/glasssizes/movingaverage/chartdata${queryString}`, { reportingAPI: true })
  }


  // Purchasing
  getPurchaseOrderSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.reportingHttpClient.get(`/intelligence/purchasing/summary${queryString}`)
  }
  // Incoming Stock
  getPurchasingIncomingStockSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.reportingHttpClient.get(`/intelligence/purchasing/stockincoming/summary${queryString}`)
  }
  getPurchasingIncomingStockList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.reportingHttpClient.get(`/intelligence/purchasing/stockincoming${queryString}`)
  }
  getPurchasingReorderReport(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.reportingHttpClient.get(`/intelligence/purchasing/stockreorder/report${queryString}`)
  }
  getPurchasingSupplierChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.reportingHttpClient.get(`/intelligence/purchasing/supplier/chartdata${queryString}`)
  }
  calculatePurchasingContainerReorderList(data) {

    return this.reportingHttpClient.post(`/intelligence/purchasing/containerreorder/calculate`, data)
  }


  // Orders
  // Today's Order Summary
  getOrdersValueTotalSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/ordervalue/todaysummary${queryString}`, { reportingAPI: true })
  }
  // Order Value
  getOrdersValueSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/ordervalue/summary${queryString}`, { reportingAPI: true })
  }
  getOrdersValueFullSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/ordervalue/fullsummary${queryString}`, { reportingAPI: true })
  }
  // Detailed Data
  getOrdersValueGlassDetailedList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/ordervalue/detailedlist/glass${queryString}`, { reportingAPI: true })
  }
  getOrdersValueServicesDetailedList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.reportingHttpClient.get(`/intelligence/orders/ordervalue/detailedlist/services${queryString}`)
  }
  getOrdersValueGeneralDetailedList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.reportingHttpClient.get(`/intelligence/orders/ordervalue/detailedlist/general${queryString}`)
  }
  // Breakdown
  getOrdersValueBreakdown(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/ordervalue/breakdown${queryString}`, { reportingAPI: true })
  }
  // Chartdata
  getOrdersValueChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/ordervalue/chartdata${queryString}`, { reportingAPI: true })
  }

  // OrderItems
  // Order Item Value Summary
  getOrderItemsValueSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/orderitems/summary${queryString}`, { reportingAPI: true })
  }

  // PriceGroup Chartdata
  getOrderItemsPriceGroupChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/orderitems/pricegroups/chartdata${queryString}`, { reportingAPI: true })
  }

  // Orders Production Breakdown
  getOrderProductionBreakdown(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/production/breakdown${queryString}`, { reportingAPI: true })
  }
  // Orders Despatch Breakdown
  getOrderDespatchBreakdown(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/despatch/breakdown${queryString}`, { reportingAPI: true })
  }

  // NCR Value
  getNCRValueSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/ncrvalue/summary${queryString}`, { reportingAPI: true })
  }
  getNCROrders(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.reportingHttpClient.get(`/intelligence/orders/ncrvalue/orders${queryString}`)
  }
  getNCRValueBreakdown(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/ncrvalue/breakdown${queryString}`, { reportingAPI: true })
  }
  // Quotes
  getQuoteValueBreakdown(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/quotevalue/breakdown${queryString}`, { reportingAPI: true })
  }
  getOrdersDurationChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/orders/orderduration/chartdata${queryString}`, { reportingAPI: true })
  }

  // Order DIFOT
  getOrderDIFOTBreakdown(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/orders/difot/breakdown${queryString}`, { reportingAPI: true })
  }
  getOrderDIFOTSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/orders/difot/summary${queryString}`, { reportingAPI: true })
  }
  getOrderDIFOTPendingDespatchList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/orders/difot/waiting${queryString}`, { reportingAPI: true })
  }
  getOrderDIFOTLateList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/orders/difot/orders/late${queryString}`, { reportingAPI: true })
  }
  getDIFOTCollectionSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/orders/difot/collection/summary${queryString}`, { reportingAPI: true })
  }
  getContactDIFOTCollectionDelayList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/orders/difot/collection/delay/orders${queryString}`, { reportingAPI: true })
  }
  getOrderDIFOTRecentCollectionList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/orders/difot/collection/orders/recent${queryString}`, { reportingAPI: true })
  }
  getOutboundTaskDIFOTList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/orders/difot/tasks${queryString}`, { reportingAPI: true })
  }
  getOrderDIFOTChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/orders/difot/chartdata${queryString}`, { reportingAPI: true })
  }
  getOrderDIFOTCollectionDelayChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/orders/difot/collection/delay/chartdata${queryString}`, { reportingAPI: true })
  }

  // Production
  // Recut Value
  getRecutValueSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/recutvalue/summary${queryString}`, { reportingAPI: true })
  }
  getRecutPanels(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })
    return this.cachedGet(`/intelligence/production/recutvalue/panels${queryString}`, { reportingAPI: true })
  }
  // Stages
  getProductionStagesSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/stages/summary${queryString}`, { reportingAPI: true })
  }
  // Chartdata
  getProductionStagesChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/stages/chartdata${queryString}`, { reportingAPI: true })
  }
  getProductionLeanSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/stages/leansummary${queryString}`, { reportingAPI: true })
  }
  getProductionStageCapacitySummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/stages/capacity/summary${queryString}`, { reportingAPI: true })
  }
  getProductionStageSessionSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/stages/sessions/summary${queryString}`, { reportingAPI: true })
  }
  getProductionStageTasksCompletedChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/performance/stagetasks/completed/chartdata${queryString}`, { reportingAPI: true })
  }
  // Production Current Summary
  getProductionSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/summary${queryString}`, { reportingAPI: true })
  }
  // Performance
  getProductionPerformanceSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/performance/summary${queryString}`, { reportingAPI: true })
  }
  // Breakdown
  getProductionBreakdownSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/performance/breakdown${queryString}`, { reportingAPI: true })
  }
  // Breakdown
  getProductionPanelDueData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/performance/duedatelist${queryString}`, { reportingAPI: true })
  }
  // Capacity Summary
  getProductionCapacitySummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/performance/capacitysummary${queryString}`, { reportingAPI: true })
  }
  // Chartdata
  getProductionCapacityChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/performance/capacity/chartdata${queryString}`, { reportingAPI: true })
  }

  // Toughening
  getTougheningYieldChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/toughening/yield/chartdata${queryString}`, { reportingAPI: true })
  }
  // Despatch
  getProductionDespatchSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/despatch/summary${queryString}`, { reportingAPI: true })
  }
  // Optimiser
  getProductionOptimiserSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/optimiser/summary${queryString}`, { reportingAPI: true })
  }
  getProductionOptimiserStockBreakdown(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/optimiser/stock${queryString}`, { reportingAPI: true })
  }
  getProductionOptimiserStockAllocations() {
    return this.cachedGet(`/intelligence/production/optimiser/stockalloc`, { reportingAPI: true })
  }
  getOptimiserStatsChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/production/optimiser/stats/chartdata${queryString}`, { reportingAPI: true })
  }

  // Tasks
  getTasksScannedItemsTaskTypesChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/tasks/despatch/tasktypes/scanneditems/chartdata${queryString}`, { reportingAPI: true })
  }
  getTasksScannedItemsPrimaryUserChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/tasks/despatch/primaryusers/scanneditems/chartdata${queryString}`, { reportingAPI: true })
  }
  getTasksDespatchArrivalDepartureSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/tasks/despatch/arrivaldeparture/summary${queryString}`, { reportingAPI: true })
  }


  // Accounts
  getAccountsSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/accounts/summary${queryString}`, { reportingAPI: true })
  }
  getAccountsInvoiceSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/accounts/invoices/summary${queryString}`, { reportingAPI: true })
  }
  // Invoice Value
  getInvoiceValueSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/accounts/invoices/summary${queryString}`, { reportingAPI: true })
  }
  getInvoicesValueFullSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/accounts/invoices/fullsummary${queryString}`, { reportingAPI: true })
  }
  // Detailed Data
  getInvoiceValueGlassDetailedList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.reportingHttpClient.get(`/intelligence/accounts/invoices/detailedlist/glass${queryString}`)
  }
  getInvoiceValueServicesDetailedList(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.reportingHttpClient.get(`/intelligence/accounts/invoices/detailedlist/services${queryString}`)
  }
  // Breakdown
  getInvoiceValueBreakdown(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/accounts/invoices/breakdown${queryString}`, { reportingAPI: true })
  }
  // Chartdata
  getInvoiceValueChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/accounts/invoices/chartdata${queryString}`, { reportingAPI: true })
  }
  getAccountsAgedTrialBalance(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/accounts/accountsreceivable/agedtrialbalance${queryString}`, { reportingAPI: true })
  }

  // Payments
  getPaymentsValueChartData(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/accounts/paymentreceiveds/chartdata${queryString}`, { reportingAPI: true })
  }
  // Invoice Value
  getPaymentsSummary(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.cachedGet(`/intelligence/accounts/paymentreceiveds/summary${queryString}`, { reportingAPI: true })
  }

  // Custom Pricing Report
  getCustomerPricingReport(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.reportingHttpClient.get(`/intelligence/pricing/customerpricing/report${queryString}`)
  }

  // Customer Price Lists Report
  getCustomerPriceListReport(filter = {}) {
    let queryString = buildUrl({ queryParams: filter })

    return this.reportingHttpClient.get(`/intelligence/pricing/pricelist/report${queryString}`)
  }
}